import React, { useEffect, useState } from "react";

import { LoadingScreen } from "./components/LoadingScreen";
import { Profile } from "./components/Profile";
import { Introduction } from "./components/Introduction";
import { Contact } from "./components/Contact";
import { Experience } from "./components/Experience";

const resumeJson = "/website-resume.json";

export function App() {
    const [apiData, setApiData] = useState(null);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);

    useEffect(() => {
        fetch(resumeJson)
            .then((response) => {
                if (!response.ok) {
                    throw new Error(`Error status: ${response.status}`);
                }

                return response.json();
            })
            .then((data) => {
                setApiData(data);
                setLoading(false);
            })
            .catch((err) => {
                setError(err);
                setLoading(true);
            });
    }, []);

    if (loading) {
        return <LoadingScreen />;
    }

    if (error) {
        return <div>Error: {error.message}</div>;
    }

    return (
        <main className="main">
            <nav className="page-nav" aria-label="Section navigation">
                <a href="#about">About</a>
                <a href="#experience">Experience</a>
                <a href="#contact">Contact</a>
            </nav>

            {apiData && (
                <>
                    <section className="section-card" id="about">
                        <div className="profile-overview">
                            <Profile />
                            <Introduction />
                        </div>
                    </section>

                    <Experience resume={apiData} />

                    <Contact />
                </>
            )}
        </main>
    );
}